import {
  UIRouter,
  ResolveTypes,
  Transition
} from '@uirouter/angular';
import { UserModel } from '../models/user.model';

export function resolveWaitForUserFn(trans: Transition) {
  const currentUserPromise: Promise<UserModel> = trans.injector().getAsync('loadUser');
  const params = trans.params();

  return new Promise((resolve, reject) => {
    currentUserPromise
      .then(
        (currentUser) => {
          resolve();
        }
      )
      .catch((err) => {
        reject(err);
      });
  });
}

export let resolveWaitForUser: ResolveTypes = {
  token: 'waitForUser',
  deps: [Transition, 'loadUser'],
  resolveFn: resolveWaitForUserFn,
  policy: {async: 'WAIT'}
};



// WEBPACK FOOTER //
// ./src/app/auth/resolves/waitForUser.resolve.ts